import React from "react";
import styles from "./Rewards.module.css";
import {
  FaTrophy,
  FaIndustry,
  FaExclamationCircle,
  FaAward,
  FaMedal,
  FaCertificate,
} from "react-icons/fa";

const Rewards = () => {
  return (
    <div className={styles.rewardsBG}>
      <div className={styles.rewards}>
        <div className={styles.rewardsHeader}>
          <h2 className={styles.headerTitle}>
            Rewards & Recognition of{" "}
            <span className={styles.highlightIRL}>IRL top performers</span>
          </h2>
        </div>

        <div className={styles.championsSection}>
          <div className={styles.championCategories}>
            <div className={styles.championCard}>
              <h4 className={styles.cardTitle}>Overall Champions - Seniors</h4>
              <div className={styles.iconWrapper}>
                <FaTrophy />
              </div>
              <p className={styles.cardDescription}>
                50,000 INR worth Robotics Kits for overall champions
              </p>
            </div>

            <div className={styles.championCard}>
              <h4 className={styles.cardTitle}>Overall Champions - Juniors</h4>
              <div className={styles.iconWrapper}>
                <FaTrophy />
              </div>
              <p className={styles.cardDescription}>
                40,000 INR worth Robotics Kits for overall champions
              </p>
            </div>
          </div>

          <div className={styles.industrialVisit}>
            <p className={styles.visitText}>
              All champions will be on for an Industrial Visit and interact with
              Tech, R&D Teams and explain IRL the project to corporates.
            </p>
          </div>
        </div>

        {/* Rewards Categories Section */}
        <div className={styles.placementRewards}>
          <div className={styles.rewardsHeader}>
            <h2 className={styles.headerTitle}>
              Rewards of IRL for 1st, 2nd & 3rd Place
            </h2>
          </div>

          <div className={styles.rewardsCategories}>
            {/* Overall Champions */}
            <div className={styles.categoryCard}>
              <h4 className={styles.cardTitle}>OVERALL CHAMPIONS</h4>
              <ul className={styles.rewardsList}>
                <li>
                  <FaTrophy className={styles.icon} /> Trophy
                </li>
                <li>
                  <FaMedal className={styles.icon} /> Medals
                </li>
                <li>
                  <FaCertificate className={styles.icon} /> Certificate
                </li>
              </ul>
            </div>

            {/* Robo Game */}
            <div className={styles.categoryCard}>
              <h4 className={styles.cardTitle}>ROBO GAME</h4>
              <ul className={styles.rewardsList}>
                <li>
                  <FaTrophy className={styles.icon} /> Trophy
                </li>
                <li>
                  <FaMedal className={styles.icon} /> Medals
                </li>
                <li>
                  <FaCertificate className={styles.icon} /> Certificate
                </li>
              </ul>
            </div>

            {/* Engineering Design */}
            <div className={styles.categoryCard}>
              <h4 className={styles.cardTitle}>ENGINEERING DESIGN</h4>
              <ul className={styles.rewardsList}>
                <li>
                  <FaTrophy className={styles.icon} /> Trophy
                </li>
                <li>
                  <FaMedal className={styles.icon} /> Medals
                </li>
                <li>
                  <FaCertificate className={styles.icon} /> Certificate
                </li>
              </ul>
            </div>

            {/* Robo Coding */}
            <div className={styles.categoryCard}>
              <h4 className={styles.cardTitle}>ROBO CODING</h4>
              <ul className={styles.rewardsList}>
                <li>
                  <FaTrophy className={styles.icon} /> Trophy
                </li>
                <li>
                  <FaMedal className={styles.icon} /> Medals
                </li>
                <li>
                  <FaCertificate className={styles.icon} /> Certificate
                </li>
              </ul>
            </div>
          </div>

          <p className={styles.note}>
            *Note: Team that has not won will receive participation
            certification
          </p>
        </div>
      </div>
    </div>
  );
};

export default Rewards;
